/**
 * Conformance Phase 3 — runtime schema for selfCheck options.
 */
import { z } from 'zod'

export const SelfCheckOptionsSchema = z
	.object({
		budgetMs: z.number().int().positive().max(5000).optional(),
		minSeverity: z.enum(['critical', 'major', 'minor', 'info']).optional(),
		locale: z.string().min(2).max(35).optional(),
	})
	.strict()

export type SelfCheckOptionsInput = z.infer<typeof SelfCheckOptionsSchema>
